import React from 'react';
import { Icon } from './Icon';

const ArrowRightIcon = ({ fill, ...rest }: Icon) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      {...rest}
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.71,9.29l-6-6C12.53,3.11,12.28,3,12,3c-0.55,0-1,0.45-1,1
			c0,0.28,0.11,0.53,0.29,0.71L15.59,9H2c-0.55,0-1,0.45-1,1c0,0.55,0.45,1,1,1h13.59l-4.29,4.29C11.11,15.47,11,15.72,11,16
			c0,0.55,0.45,1,1,1c0.28,0,0.53-0.11,0.71-0.29l6-6C18.89,10.53,19,10.28,19,10C19,9.72,18.89,9.47,18.71,9.29z"
          fill={fill || 'currentColor'}
        />
      </g>
    </svg>
  );
};

export default ArrowRightIcon;
